import { ImageCell } from '@/components/shared/ImageCell';
import type { Amenity } from '@/config/objects/amenities';

interface AmenityImageCellProps {
  amenity?: Amenity;
  size?: 'sm' | 'lg';
}

/**
 * Editable amenity image cell component with upload and delete actions
 */
export function AmenityImageCell({ amenity, size = 'sm' }: AmenityImageCellProps) {
  return (
    <ImageCell
      item={amenity}
      endpoint="/amenities"
      entityName="Amenity"
      imageLabel="Amenity Image"
      getFeaturedImage={(item) => item.featuredImage}
      getItemId={(item) => item.id}
      size={size}
    />
  );
}
